"use strict";
window.DecidimBudgets = window.DecidimBudgets || {};
const patchFoundationOpenListener = () => {
  var _a, _b, _c;
  const $ = window.jQuery;
  const Basic = (_c = (_b = (_a = window.Foundation) == null ? void 0 : _a.Triggers) == null ? void 0 : _b.Listeners) == null ? void 0 : _c.Basic;
  if (!Basic) {
    return;
  }
  if (!Basic._openListenerPatched && Basic.openListener) {
    const origOpenListener = Basic.openListener;
    Basic.openListener = function(...args) {
      if (!this) {
        return;
      }
      const el = $(this);
      const dataOpen = el.data("open");
      if (typeof dataOpen !== "string" || !dataOpen.trim() || el.closest("[data-controller='accordion'], [data-controller='dropdown']").length > 0) {
        return;
      }
      return origOpenListener.apply(this, args);
    };
    Basic._openListenerPatched = true;
  }
  if ($ && Basic.openListener) {
    $(document).off("click.zf.trigger", Basic.openListener);
  }
};
document.addEventListener("DOMContentLoaded", patchFoundationOpenListener);
document.addEventListener("turbo:load", patchFoundationOpenListener);
window.addEventListener("load", patchFoundationOpenListener);
document.addEventListener("turbo:load", () => {
  const backdrop = document.getElementById("progress-summary-backdrop");
  const button = document.getElementById("progress-summary-button");
  if (backdrop && button) {
    backdrop.addEventListener("click", () => {
      backdrop.classList.add("hidden");
      if (button.getAttribute("aria-expanded") === "true") {
        button.click();
      }
    });
    button.addEventListener("click", () => {
      setTimeout(() => {
        const isOpen = button.getAttribute("aria-expanded") === "true";
        backdrop.classList.toggle("hidden", !isOpen);
      }, 0);
    });
  }
});
